import { useQuery } from '@tanstack/react-query';
import { registration } from '@/api';
import { type AttendeeCategoryData } from '@/api/registration';
import { useTenantApi } from '@/account/hook/useTenantApi';

/**
 * !!! WRONG METHOD NAME. The query here returns the attendee category list so the method name should be 'useAttendeeCategoryListQuery'.
 */
export function useAttendeeCategoryQuery(eventId: string) {
  const { createTenantAdminApiRequest, isLoading: isApiPreparing } = useTenantApi();
  return useQuery<AttendeeCategoryData[], Error>({
    queryKey: [registration.attendeeCategoryListQueryKey, { eventId }],
    queryFn: async () => {
      const result = await registration.loadAttendeeCategoryList(createTenantAdminApiRequest)({ eventId });
      return result.items?.[0]; // !!! Why the API return the attendee list array inside another array???
    },
    enabled: !isApiPreparing && !!eventId,
  });
}
